import { render, staticRenderFns } from "./ReturnRiskCost.vue?vue&type=template&id=bce0edaa&scoped=true"
import script from "./ReturnRiskCost.vue?vue&type=script&lang=js"
export * from "./ReturnRiskCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce0edaa",
  null
  
)

export default component.exports